import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import styled, { css, ThemeContext } from 'styled-components';

import { Show } from '../../../show';

import { useWindowSize } from '../../../../lib/hooks';

const HiddenBelowOrAbove = styled.div`
    ${(props) =>
        props.print &&
        css`
            @media print {
                display: none;
            }
        `}

    ${(props) =>
        props.below &&
        css`
            display: none;

            ${(props) => props.theme.mediaQueries[props.below]} {
                display: inherit;
            }
        `}

    ${(props) =>
        props.above &&
        css`
            display: inherit;

            ${(props) => props.theme.mediaQueries[props.above]} {
                display: none;
            }
        `}
`;

const Hidden = (props) => {
    const { breakpoints } = useContext(ThemeContext);
    const { innerWidth } = useWindowSize();

    let isHidden = !!props.below;
    if (props.below) {
        isHidden = innerWidth < breakpoints[props.below];
    }

    if (props.above) {
        isHidden = innerWidth >= breakpoints[props.above];
    }

    return (
        <Show when={!isHidden}>
            <HiddenBelowOrAbove {...props} />
        </Show>
    );
};

Hidden.propTypes = {
    print: PropTypes.bool,
    above: PropTypes.oneOf(['mobile', 'tablet', 'desktop']),
    below: PropTypes.oneOf(['mobile', 'tablet', 'desktop']),
    children: PropTypes.node,
};

export default Hidden;
